import { useEffect, useRef, useState } from 'react';

export function useFadeSlide({
                               visible,
                               enter = 'fadeDown',   // 'none' | 'fadeDown' | 'fadeUp'
                               exit  = 'fadeUp',      // 'none' | 'fadeDown' | 'fadeUp'
                               duration = 220,
                               offset = 24,
                             }) {
  const [mounted, setMounted] = useState(false);
  const [phase, setPhase] = useState('idle'); // 'idle' | 'enterStart' | 'enterEnd' | 'exit'
  const nodeRef = useRef(null);

  useEffect(() => {
    if (visible) {
      setMounted(true);
      if (enter === 'none' || duration === 0) {
        setPhase('enterEnd');
      } else {
        setPhase('enterStart');
        requestAnimationFrame(() => setPhase('enterEnd'));
      }
    } else {
      if (!mounted) return;
      if (exit === 'none' || duration === 0) {
        setMounted(false);
      } else {
        setPhase('exit');
      }
    }
  }, [visible, enter, exit, duration, mounted]);

  useEffect(() => {
    if (!mounted) return;
    const el = nodeRef.current;
    if (!el) return;
    const onEnd = (e) => {
      if (e.target !== el) return;
      if (phase === 'exit') setMounted(false);
    };
    el.addEventListener('transitionend', onEnd);
    return () => el.removeEventListener('transitionend', onEnd);
  }, [mounted, phase]);

  const enterY = enter === 'fadeDown' ? offset : enter === 'fadeUp' ? -offset : 0;
  const exitY  = exit  === 'fadeDown' ? offset : exit  === 'fadeUp' ? -offset : 0;

  let opacity = 1;
  let slide = 0;
  if (phase === 'enterStart') { opacity = 0; slide = enterY; }
  if (phase === 'enterEnd')   { opacity = 1; slide = 0; }
  if (phase === 'exit')       { opacity = 0; slide = exitY; }

  return {
    mounted,
    phase,
    nodeRef,
    style: {
      opacity,
      transform: `translateY(${slide}px)`,
      transition: duration > 0 ? `opacity ${duration}ms ease, transform ${duration}ms ease` : 'none',
      willChange: 'opacity, transform',
      pointerEvents: phase === 'exit' ? 'none' : 'auto',
    },
    duration,
  };
}
